export default class PersonalInfoRepository {
  get() {
    // Implementation for getting personal info by id
  }

  save(personalInfo) {
    // Implementation for saving personal info
  }
}
